import React from "react";
import {useNavigate} from "react-router-dom";

const RegisterFormStep5 = () => {
    const navigate = useNavigate();

    return (
        <div className="w-100 py-5 flex justify-center items-center">
            <div className="bg-gray-200 pb-4 rounded-lg px-5 shadow-lg w-full max-w-[400px] text-center">
                <div className="py-5 flex flex-col items-center justify-center gap-4">
                    {/* Congratulation Heading */}
                    <h1 className="font-bold text-2xl text-gray-700">
                        Congratulations!
                    </h1>

                    {/* Success Message */}
                    <p className="text-gray-600 text-sm">
                        You have successfully completed the registration process.
                    </p>

                    {/* Instruction or Call-to-action */}
                    <button
                        className="bg-black text-white px-6 py-2 rounded-md mt-4 hover:bg-gray-800"
                        onClick={() => {
                            navigate("/");
                        }}
                    >
                        Go to Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RegisterFormStep5;